import React from "react";
import { Link, NavLink } from "react-router-dom";
import {
  FaArrowRightFromBracket,
  FaAnglesRight,
  FaAnglesLeft,
} from "react-icons/fa6";
import { RiFileCopyLine, RiUserLine, RiBarChart2Line } from "react-icons/ri";
import { AiOutlineInfoCircle, AiOutlineShopping } from "react-icons/ai";
import logo from "../assets/images/WreckconnectLogo.png";
import { LuUsers2 } from "react-icons/lu";
import { LiaUserClockSolid } from "react-icons/lia";
import { IoFlag } from "react-icons/io5";
import { BiSolidHide } from "react-icons/bi";
import { IoMdEye } from "react-icons/io";

const data = [
  {
    name: "Requests",
    link: "requests",
    icon: <FaArrowRightFromBracket />,
  },
  {
    name: "Quotes",
    link: "quotes",
    icon: <RiFileCopyLine />,
  },
  {
    name: "Orders",
    link: "orders",
    icon: <AiOutlineShopping />,
  },
  {
    name: "Request Credit",
    link: "support",
    icon: <AiOutlineInfoCircle />,
  },
  {
    name: "Hidden Requests",
    link: "hiddenData",
    icon: <IoMdEye />,
  },
  {
    name: "Administration",
    link: "administration",
    icon: <RiUserLine />,
  },
  {
    name: "Users",
    link: "users",
    icon: <LuUsers2 />,
  },
  {
    name: "Reports",
    link: "report",
    icon: <RiBarChart2Line />,
  },
  {
    name: "Quotes",
    link: "/adminquotes",
    icon: <RiFileCopyLine />,
  },
];

const Sidebar = ({ isOpen, toggleBar }) => {
  let role = localStorage.getItem("role");

  return (
    <div>
      <div>
        <div
          className={`py-4 px-6 bg-regalBlue text-white flex items-center gap-2 ${
            isOpen ? "justify-center" : "justify-between"
          }`}
        >
          <Link to="/requests" className={`${isOpen ? "hidden" : "block "}`}>
            <img src={logo} alt="wreckonnect" />
          </Link>
          <div className="text-[26px] cursor-pointer">
            <span onClick={toggleBar}>
              {isOpen ? <FaAnglesRight /> : <FaAnglesLeft />}
            </span>
          </div>
        </div>
        <div className="p-3">
          {data.map((item, index) => {
            /* ★ NEW – “Hidden Requests” sirf SUPPLIER ko dikhni chahiye */
            if (item.name === "Hidden Requests" && role !== "SUPPLIER") {
              return null; // ← admin ya customer hon to skip kar do
            }

            return (
              <NavLink to={`${item.link}`} key={index}>
                <div
                  className={`py-3 text-[0.85rem] mb-2 cursor-pointer font-semibold flex ${
                    isOpen ? "items-center justify-center " : "pl-4"
                  } ${
                    (role === "CUSTOMER" || role === "SUPPLIER") && index > 3
                      ? "hidden"
                      : "block"
                  } ${
                    role === "ADMIN" && index < 4 ? "hidden" : "block"
                  } gap-3 items-center rounded-2xl hover:bg-regalBlue hover:text-white box-border`}
                >
                  <span>{item.icon}</span>
                  <span className={`${isOpen ? "hidden" : "block"}`}>
                    {item.name}
                  </span>
                </div>
              </NavLink>
            );
          })}

          {/* ────────────────────────────────────────────────────────────── */}
          {/* Added one more block for "Request Credit" below              */}
          {role === "SUPPLIER" && (
            <NavLink to="/hiddenData">
              <div
                className={`py-3 text-[0.85rem] mb-2 cursor-pointer font-semibold flex ${
                  isOpen ? "items-center justify-center " : "pl-4"
                } gap-3 items-center rounded-2xl hover:bg-regalBlue hover:text-white box-border`}
              >
                <span>
                  <BiSolidHide />
                </span>
                <span className={`${isOpen ? "hidden" : "block"} `}>
                  Hidden Requests
                </span>
              </div>
            </NavLink>
          )}
          {/* ────────────────────────────────────────────────────────────── */}

          <NavLink to={`/requestApproval`}>
            <div
              className={`py-3 text-[0.85rem] mb-2 cursor-pointer font-semibold flex ${
                isOpen ? "items-center justify-center " : "pl-4"
              } ${
                role === "ADMIN" ? "block" : "hidden"
              } gap-3 items-center rounded-2xl hover:bg-regalBlue hover:text-white box-border`}
            >
              <span>
                <LiaUserClockSolid />
              </span>
              <span className={`${isOpen ? "hidden" : "block"} `}>
                User Requests
              </span>
            </div>
          </NavLink>
          <NavLink to={`/flaggedComment`}>
            <div
              className={`py-3 text-[0.85rem] mb-2 cursor-pointer font-semibold flex ${
                isOpen ? "items-center justify-center " : "pl-4"
              } ${
                role === "ADMIN" ? "block" : "hidden"
              } gap-3 items-center rounded-2xl hover:bg-regalBlue hover:text-white box-border`}
            >
              <span>
                <IoFlag />{" "}
              </span>
              <span className={`${isOpen ? "hidden" : "block"} `}>
                Flagged Comment
              </span>
            </div>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
